export default __webpack_public_path__ + "static/media/ve.5856c785.jpg";